export enum MachineCommandStateEnum {
  timeout = 'Timeout',
  received = 'Ricevuto',
  pending = 'In esecuzione...',
  failed = 'Errore',
  forceClosed = 'Annullamento forzato',
  expired = 'Scaduto',
}
